var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTailoredReportIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 101 110",
    style: {
      enableBackground: "new 0 0 101 110"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E4EAF7;}\n\t.st2{fill:none;}\n\t.st3{fill:#212223;}\n\t.st4{fill:#FFFFFF;stroke:#FFFFFF;stroke-miterlimit:10;}\n\t.st5{fill:#019CAE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "journal_00000118360895997109706370000003892091312053733516_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_488_00000144330811283441433830000018037004918977602211_",
    className: "st0",
    d: "M65,50.3l11.6-2.2v47L43,101.6v-47 L65,50.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_489_00000009553689285137125470000011014587976638213823_",
    className: "st1",
    d: "M65,50l-22.2,4.3L20.7,50 c0.3-8,6.8-14.3,14.8-14.3h14.7C58.2,35.7,64.7,42,65,50z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_490_00000068669085771460231020000018034555503792484522_",
    className: "st1",
    d: "M42.8,8.7c6.1,0,11,4.9,11,11 c0,6.1-4.9,11-11,11c-6.1,0-11-4.9-11-11c0,0,0,0,0,0C31.8,13.7,36.7,8.7,42.8,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_491_00000052087688014043195690000009627801661333131955_",
    className: "st0",
    d: "M20.7,50.3l22,4.3v47L9.1,95.1v-47 L20.7,50.3z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_382_00000132767789424996771030000017668653046718162864_",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M50.2,37.1H35.5c-6.6,0.1-12.2,5-13.1,11.5l20.4,4l20.4-4C62.4,42.1,56.8,37.1,50.2,37.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "10.6,93.7 41.2,99.6 41.2,55.5 10.6,49.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "65.3,51.5 44.4,55.5 44.4,99.6 75.1,93.7 75.1,49.6 65.3,51.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.5,46c-0.1,0-0.1,0-0.2,0L66.4,48c-1.2-8.1-8.1-14.1-16.2-14.1H35.5c-8.2,0-15,6-16.2,14.1l-9.9-1.9 c-0.5-0.1-1,0-1.4,0.3c-0.4,0.3-0.6,0.8-0.6,1.2V95c0,0.8,0.6,1.4,1.3,1.6l33.8,6.5c0.1,0,0.2,0,0.3,0c0.1,0,0.2,0,0.3,0L77,96.6 c0.8-0.1,1.3-0.8,1.3-1.6V47.6C78.2,46.7,77.5,46,76.5,46z M41.2,99.6l-30.7-5.9V49.6l30.7,5.9V99.6z M42.8,52.6l-20.4-4 c0.9-6.6,6.5-11.5,13.1-11.5h14.7c6.6,0.1,12.2,5,13.1,11.5L42.8,52.6z M75.1,93.7l-30.7,5.9V55.5l20.8-4.1h0l9.8-1.9V93.7z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_493_00000120517880189141039630000011106635162901555364_",
    className: "st3",
    d: "M14.9,58.9l21.4,4.1 c0.9,0.1,1.7-0.4,1.8-1.3c0.1-0.8-0.4-1.6-1.2-1.8l-21.4-4.1c-0.9-0.1-1.7,0.4-1.8,1.3C13.5,57.9,14.1,58.7,14.9,58.9L14.9,58.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_494_00000043448123049799638430000002698678099509532034_",
    className: "st3",
    d: "M36.8,66l-21.4-4.1 c-0.9-0.2-1.7,0.4-1.9,1.2C13.4,64,14,64.8,14.8,65c0,0,0.1,0,0.1,0l21.4,4.1c0.9,0.2,1.7-0.4,1.9-1.2C38.3,67,37.8,66.2,36.8,66 C36.9,66,36.9,66,36.8,66L36.8,66z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_495_00000011014109544772882390000011782156944505162382_",
    className: "st3",
    d: "M14.9,71.1l21.4,4.1 c0.9,0.2,1.7-0.4,1.9-1.2c0.2-0.9-0.4-1.7-1.2-1.9c0,0-0.1,0-0.1,0L15.5,68c-0.9-0.1-1.7,0.4-1.8,1.3C13.5,70.2,14.1,71,14.9,71.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_496_00000015351095754445297650000017163503458025419191_",
    className: "st3",
    d: "M14.9,77.3l21.4,4.1 c0.9,0.1,1.7-0.4,1.8-1.3c0.1-0.8-0.4-1.6-1.2-1.8l-21.4-4.1c-0.9-0.2-1.7,0.4-1.9,1.2C13.4,76.2,14,77.1,14.9,77.3 C14.8,77.3,14.9,77.3,14.9,77.3L14.9,77.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_497_00000127750410232430185660000014923054575044980640_",
    className: "st3",
    d: "M36.8,84.4l-21.4-4.1 c-0.9-0.2-1.7,0.4-1.9,1.2c-0.2,0.9,0.4,1.7,1.2,1.9c0,0,0.1,0,0.1,0l21.4,4.1c0.9,0.1,1.7-0.4,1.8-1.3 C38.2,85.3,37.7,84.6,36.8,84.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_498_00000141438905792711836290000003243749950111330177_",
    className: "st3",
    d: "M36.8,90.6l-21.4-4.1 c-0.9-0.2-1.7,0.4-1.9,1.2c-0.2,0.9,0.4,1.7,1.2,1.9c0,0,0.1,0,0.1,0l21.4,4.1c0.9,0.2,1.7-0.4,1.9-1.2 C38.3,91.6,37.8,90.8,36.8,90.6C36.9,90.6,36.9,90.6,36.8,90.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_499_00000013905957690505122660000002295257758968521400_",
    className: "st3",
    d: "M42.8,32.4c7,0,12.6-5.6,12.6-12.6 c0-7-5.6-12.6-12.6-12.6c-7,0-12.6,5.6-12.6,12.6c0,0,0,0,0,0C30.2,26.7,35.8,32.4,42.8,32.4z M42.8,10.3c5.2,0,9.4,4.2,9.4,9.4 c0,5.2-4.2,9.4-9.4,9.4s-9.4-4.2-9.4-9.4S37.6,10.3,42.8,10.3C42.8,10.3,42.8,10.3,42.8,10.3z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_834",
    transform: "translate(-1519.053 -522.538)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "repair",
    transform: "translate(1573 554)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_179",
    className: "st4",
    cx: 22.8,
    cy: 22.3,
    r: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_627",
    className: "st5",
    d: "M22.8,4.8c-9.6,0-17.5,7.8-17.5,17.5s7.8,17.5,17.5,17.5s17.5-7.8,17.5-17.5l0,0 C40.2,12.6,32.4,4.8,22.8,4.8z M28.9,14.3c-0.2-0.2-0.2-0.5,0-0.7l1.8-1.5l0,0c0.2-0.2,0.4-0.3,0.7-0.3c0.1,0,0.3,0,0.4,0.1 l1.2,1.2c0.1,0.1,0.2,0.3,0.1,0.5c0,0.2-0.1,0.4-0.3,0.6L31.3,16c-0.1,0.1-0.2,0.1-0.3,0.1c-0.1,0-0.3,0-0.4-0.1l-0.2-0.1 l-3.8,3.9L25,18.4l4-3.9L28.9,14.3z M22.4,27.2l-5.1,5.1c-1.1,1.1-2.8,1.1-3.8,0c0,0,0,0,0,0l-0.9-0.9c-1.1-1.1-1.1-2.8,0-3.8 c0,0,0,0,0,0l5-5c0.3,0,0.7-0.1,1-0.1l3.9,4.5C22.5,27.1,22.4,27.2,22.4,27.2z M32.5,31.3c-0.6,0.5-1.4,0.8-2.2,0.8 c-0.5,0-1.1-0.2-1.5-0.5l-9.6-11.1c-0.8,0.3-1.6,0.4-2.4,0.4c-1.3,0.1-2.5-0.4-3.5-1.2c-1.5-1.3-2.1-3.3-1.5-5.2l2.9,2.5l3-0.3 l0.2-2.8l-2.5-2.9c0.5-0.2,1.1-0.3,1.6-0.3c1.4,0,2.8,0.6,3.8,1.6c1.5,1.5,1.5,4,0.9,5.9l2.6,2.3l0.9,0.8l7.6,6.5 C33.7,28.4,33.5,30.3,32.5,31.3z"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTailoredReportIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tailored-report-icon.2a6bc48b.svg";
export { ForwardRef as ReactComponent };